// extracted by mini-css-extract-plugin
export default {"tab":"Tabs--tab--E1Rb8","tabSelected":"Tabs--tabSelected--IfHcW"};